"use strict";

import Dom from "common/Dom";
var noteSuccess = function noteSuccess(data, textStatus, jqXHR) {
  window.location.href = "/checkout";
};
var _error2 = function error(_error, message) {
  console.error("Error " + _error);
  if (message && message.length > 0) {
    alert(message);
  }
};
export const updateCharCount = function updateCharCount(remaining) {
  var label = $(Dom.giftMessageChars);
  label.text(remaining + " characters left");
};
export const setNoteAndCheckout = function setNoteAndCheckout(message) {
  window.CartJS.setNote(message, {
    success: noteSuccess,
    error: function error(jqXHR, textStatus, errorThrown) {
      return _error2(errorThrown);
    },
  });
};
export const handleGiftMessageToggle = function handleGiftMessageToggle(
  toggle,
) {
  var messageBox = $(Dom.giftMessage);
  toggle ? messageBox.show() : messageBox.hide();
};
